import { Badge, Typography } from '@components/ui';
import { TInboxItem } from '@hooks/xmpp/useLastMessages';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Avatar from '../../../../components/avatar';
import { PatientSC } from './patients.styled';

type TProps = {
  item: TInboxItem;
};

const Patient: React.FC<TProps> = ({ item }) => {
  const theme = useTheme();

  return (
    <PatientSC to={`/life-id/${item.patient.id}`}>
      <div className="p-avatar">
        <Badge
          content={item.unreadsCount}
          positionHorizontal="right"
          positionVertical="top"
          badgeStyle={{ top: -2 }}
        >
          <Avatar imgUrl={item.patient.profile.profileImage} />
        </Badge>
      </div>
      <div className="p-text">
        <Typography display="body1" variant="strong">
          {item.fullName}
        </Typography>
        <Typography display="body2" style={{ color: theme.color.tint.secondary }}>
          {item.messagePreview}{' '}
        </Typography>
      </div>
    </PatientSC>
  );
};

export default Patient;
